import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import SettlementService from '@root/modules/Sellers/Settlement/services/settlement';
import settlementService from '@root/modules/Warehouse/Settlement/Services/settlementService';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import BreadcrumbList from '../../Stock/components/Breadcrumb';

interface DataType {
  key: React.Key;
  no: number;
  productName: string;
  sku: number;
  quantity: number;
  updated_at: Date;
  warehouse: string;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const SettlementList = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setStatus] = useState('');
  const [labelStatus, setLabelStatus] = useState({
    key: '1',
    label: t('seller:button:select')
  } as any);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const [totalPrice, setTotalPrice] = useState<number[]>([0.0, 0.0]);
  const [valueProname, setValueProname] = useState('');
  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const [isSearch, setIsSearch] = useState('');

  const Breadcrumb = [
    {
      tittle: '정산 관리',
      url: ''
    },
    {
      tittle: '정산 조회',
      url: ''
    }
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: '영수증 번호',
      dataIndex: 'receiptId'
    },
    {
      title: '업데이트일',
      dataIndex: 'updated_at'
    },

    {
      title: '물류창고명',
      dataIndex: 'warehouse'
    },
    {
      title: '국가',
      dataIndex: 'country'
    },
    {
      title: '금액',
      dataIndex: 'billingAmount'
    },
    {
      title: '상태',
      dataIndex: 'billingStatus'
    }
  ];
  const getStatus = (e: any) => {
    setStatus(e.key);
    setLabelStatus({ key: e.key, label: e.domEvent.target.innerText });
  };

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getStatus}
          items={[
            {
              label: '확인요청',
              key: 'request'
            },
            {
              type: 'divider'
            },
            {
              label: '결제완료',
              key: 'completed'
            }
          ]}
        />
      )
    },
    {
      id: 2,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: '영수증 번호',
              key: 'no'
            },
            {
              type: 'divider'
            },
            {
              label: '물류창고명',
              key: 'warehouseName'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      // setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.productName
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string,
    status: string
  ) => {
    if (selectedRowKeys.length > 0) {
      let selected = selectedRowKeys.map((item) => Number(item));
      const responseById = await SettlementService.exportExcelById(selected);
      const outputFilename = `Settlement_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await SettlementService.exportExcel({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt,
        status
      });
      const outputFilename = `Settlement_${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getPagination = async (
    page: number,
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string,
    status: string
  ) => {
    setLoading(true);
    try {
      const temp = await SettlementService.getPaging({
        productName,
        page,
        fieldSearch,
        sort,
        fromDt,
        toDt,
        status
      });
      // let list =temp.data

      let list = temp.data.map((item: any, index: number) => {
        return {
          ...item,
          updated_at: formatDateTime(item.updated_at),
          // updated_at: moment(item.updated_at)
          //   .utc(true ?? 9)
          //   .format('YYYY.MM.DD hh:mm:ss A '),
          warehouse: item.warehouse.name,
          country: item.warehouse.countryName,
          key: item.id,
          billingAmount: Number(item.billingAmount).toLocaleString('en-US'),
          billingStatus: getStatusSettlement(item.billingStatus)
        };
      });
      // let totalPriceFilter = temp.data.reduce((s:number ,x:any) => (s + Number(x.billingAmount)),0.00)
      setList(list);
      setTotalPages(temp.meta.totalPages);
      setCurrentPage(temp.meta.currentPage);
      setTotaItem(temp.meta.totalItems);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getStatusSettlement = (status: string) => {
    switch (status) {
      case 'Request':
        return '확인요청';
      case 'Completed':
        return '결제완료';
      default:
        return status;
    }
  };

  const getAmountInfo = async () => {
    try {
      const infoAmount = await SettlementService.getAmountInfo();
      // const infoAmountUse = infoAmount.data.map((item:number) =>{
      //   item = Number(item.toLocaleString('en-US'));
      // })
      setTotalPrice(Object.values(infoAmount.data));
    } catch (e) {
      setTotalPrice([0.0, 0.0]);
    }
  };

  useEffect(() => {
    if (!!valueSearch && !!proName) {
      if (valueSearch !== isSearch) setIsSearch(valueSearch);
      else setValueProname(proName);
    } else if (!!isSearch && !valueSearch) setIsSearch('');
  }, [debounc, proName]);

  useEffect(() => {
    getPagination(1, proName, valueSearch, sort, fromDt, toDt, status);
  }, [isSearch, valueProname, status, sort, fromDt, toDt]);

  useEffect(() => {
    getAmountInfo();
  }, []);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div style={{ display: 'flex' }}>
            <Card
              style={{
                width: '50%',
                marginBottom: '1rem',
                paddingTop: '0.5rem',
                marginRight: '1rem'
              }}
            >
              <h3 style={{ color: '#747274' }}>총 거래 금액</h3>
              <h2 style={{ color: '#747274', fontWeight: 'bold' }}>
                $ {Number(totalPrice[0]).toLocaleString('en-US')}
              </h2>
            </Card>
            <Card
              style={{
                width: '20%',
                marginBottom: '1rem',
                paddingTop: '0.5rem'
              }}
            >
              <h3 style={{ color: '#747274' }}>월별 거래 금액</h3>
              <h2 style={{ color: '#747274' }}>
                $ {Number(totalPrice[1]).toLocaleString('en-US')}
              </h2>
            </Card>
          </div>{' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              // defaultValue={[
              //   moment(moment(), dateFormat),
              //   moment(moment(), dateFormat),
              // ]}
              format={dateFormat}
            />
            <strong>상태</strong>
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={item.id === 1 ? labelStatus.label : labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    총 거래내역 &nbsp;{totalItem}
                  </span>
                  <span className="table__head --right">
                    선택 거래내역 &nbsp;
                    {selectedRowKeys.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    disabled={totalItem == 0}
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt,
                        status
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueSearch,
                      proName,
                      sort,
                      fromDt,
                      toDt,
                      status
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/settlement/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SettlementList;
